export const projectPhotos = [
  { id: 'kitchen-island', category: 'Kitchens', title: 'A gathering place at the island', image: '/images/projects/google-business/kitchen-island.webp', width: 1360, height: 1020, alt: 'Kitchen with wood cabinets, a white island countertop and pendant lights' },
  { id: 'living-room-flooring', category: 'Flooring', title: 'A lighter foundation for living', image: '/images/projects/google-business/living-room-flooring.webp', width: 1360, height: 1020, alt: 'Light wood-look flooring connecting a living room and dining area' },
  { id: 'fireplace-feature-wall', category: 'Living spaces', title: 'A focal point for the room', image: '/images/projects/google-business/fireplace-feature-wall.webp', width: 764, height: 1020, alt: 'Dark feature wall with a television above a linear fireplace' },
  { id: 'dark-cabinet-kitchen', category: 'Kitchens', title: 'Contrast in every detail', image: '/images/projects/google-business/dark-cabinet-kitchen.webp', width: 1360, height: 1020, alt: 'Dark kitchen cabinets paired with patterned countertops and stainless steel appliances' },
  { id: 'entryway-flooring', category: 'Flooring', title: 'Connected from the front door', image: '/images/projects/google-business/entryway-flooring.webp', width: 765, height: 1020, alt: 'Wood-look plank flooring extending from the entryway through a living room' },
  { id: 'wood-cabinet-kitchen', category: 'Kitchens', title: 'Warm wood, bright surfaces', image: '/images/projects/google-business/wood-cabinet-kitchen.webp', width: 1360, height: 1020, alt: 'Wood kitchen cabinets with light countertops, a tile backsplash and under-cabinet lighting' }
];

export const services = [
  {
    slug: 'kitchen-remodeling',
    shortTitle: 'Kitchens',
    title: 'Kitchen Remodeling in Maricopa, AZ',
    eyebrow: 'The heart of your home, rebuilt around you',
    description: 'From cabinets and countertops to lighting, sinks and backsplashes, we coordinate the details that turn an outdated kitchen into a hardworking, welcoming space.',
    image: '/images/projects/google-business/wood-cabinet-kitchen.webp',
    details: ['Cabinets and storage', 'Countertops and sinks', 'Tile backsplashes', 'Lighting and range hoods', 'Flooring and finish work'],
    faqs: [
      ['Can you help with kitchen design and material selections?', 'Yes. We begin with a consultation, discuss how you use the room, and help narrow down practical finishes and layout choices.'],
      ['Do you handle cabinets, counters, flooring and backsplash together?', 'Yes. We can coordinate a complete kitchen renovation so the products, schedule and installation work as one project.'],
      ['Can I see materials before making a decision?', 'Yes. Visit our Maricopa showroom or ask about an in-home consultation.']
    ]
  },
  {
    slug: 'bathroom-remodeling',
    shortTitle: 'Bathrooms',
    title: 'Bathroom Remodeling in Maricopa, AZ',
    eyebrow: 'A calmer, safer and better-planned daily space',
    description: 'We renovate showers, tubs, vanities, tile and fixtures with thoughtful layouts, durable materials and clean finish work.',
    image: '/images/projects/bathroom-after.jpg',
    details: ['Walk-in showers', 'Tile and surrounds', 'Vanities and countertops', 'Tubs, toilets and fixtures', 'Accessibility-minded updates'],
    faqs: [
      ['Can you replace a tub with a walk-in shower?', 'Yes. Tub-to-shower conversions and custom walk-in showers are common parts of our bathroom remodeling work.'],
      ['Will you help us choose tile and fixtures?', 'Yes. We help clients compare materials and create a cohesive plan before installation begins.'],
      ['Do you remodel primary and guest bathrooms?', 'Yes. We work on bathrooms of many sizes, from focused updates to complete renovations.']
    ]
  },
  {
    slug: 'flooring',
    shortTitle: 'Flooring',
    title: 'Flooring Installation in Maricopa, AZ',
    eyebrow: 'A durable foundation for every room',
    description: 'Refresh one room or create a consistent look throughout your home with professionally installed flooring selected for Arizona living.',
    image: '/images/projects/google-business/living-room-flooring.webp',
    details: ['Luxury vinyl plank', 'Tile and porcelain', 'Laminate and wood', 'Carpet', 'Removal and floor preparation'],
    faqs: [
      ['What flooring works well in Maricopa homes?', 'Tile and quality luxury vinyl plank are popular for durability and easy care, but the right choice depends on the room, traffic and look you want.'],
      ['Can you install one flooring type across several rooms?', 'Yes. We can plan transitions and installation across connected living areas for a more unified result.'],
      ['Do you remove existing flooring?', 'Removal and floor preparation can be included in the project scope after we inspect the existing surface.']
    ]
  },
  {
    slug: 'whole-home-remodeling',
    shortTitle: 'Whole-home',
    title: 'Whole-Home Remodeling in Maricopa, AZ',
    eyebrow: 'One coordinated plan for a home that works better',
    description: 'When several rooms need attention, we create a unified scope so layouts, finishes, flooring and schedules feel intentional from start to finish.',
    image: '/images/projects/google-business/fireplace-feature-wall.webp',
    details: ['Multi-room renovations', 'Finish and flooring coordination', 'Kitchen and bathroom updates', 'Interior refreshes', 'Project planning and sequencing'],
    faqs: [
      ['Can you coordinate more than one room?', 'Yes. A whole-home plan can combine kitchens, bathrooms, flooring and interior finish work into one coordinated scope.'],
      ['Where does a whole-home renovation begin?', 'It begins with your priorities, budget range and how you want the home to function. We then organize the work into a clear plan.'],
      ['Can the work be completed in phases?', 'Depending on the scope, phasing may be possible. We can discuss the best sequence during your consultation.']
    ]
  },
  {
    slug: 'countertops',
    shortTitle: 'Countertops',
    title: 'Countertops in Maricopa, AZ',
    eyebrow: 'The surface that brings the room together',
    description: 'Choose a countertop that balances daily performance and visual character, then let our team coordinate measurement, preparation and installation.',
    image: '/images/projects/google-business/kitchen-island.webp',
    details: ['Kitchen countertops', 'Bathroom vanity tops', 'Sink coordination', 'Backsplash pairing', 'Removal and installation'],
    faqs: [
      ['Can you coordinate countertops with cabinets and backsplash?', 'Yes. We look at the room as a whole so colors, patterns and edge details work together.'],
      ['Do you install bathroom countertops too?', 'Yes. Countertop work can be part of either a kitchen or bathroom renovation.'],
      ['How do I start selecting a surface?', 'Schedule a consultation or visit the showroom. We will discuss appearance, maintenance, durability and budget.']
    ]
  }
];

export const projects = [
  {
    slug: 'maricopa-kitchen-transformation',
    title: 'A Brighter, More Open Kitchen',
    category: 'Kitchen remodeling',
    summary: 'A dated kitchen becomes a brighter, more cohesive gathering space through coordinated cabinets, surfaces and finishes.',
    before: '/images/projects/kitchen-before.jpg',
    after: '/images/projects/kitchen-after.jpg'
  },
  {
    slug: 'walk-in-shower-renovation',
    title: 'A Clean, Contemporary Bathroom',
    category: 'Bathroom remodeling',
    summary: 'A bathroom refresh centered on a more polished shower, coordinated tile and an uncluttered finish palette.',
    before: '/images/projects/bathroom-before.jpg',
    after: '/images/projects/bathroom-after.jpg'
  },
  {
    slug: 'custom-tile-bathroom',
    title: 'Thoughtful Tile, Built to Last',
    category: 'Bathroom remodeling',
    summary: 'Careful tile placement and coordinated fixtures give this bath a finished, intentional feel.',
    before: '/images/projects/tile-bath-before.jpg',
    after: '/images/projects/tile-bath-after.jpg'
  }
];

export const processSteps = [
  ['01', 'Listen', 'We meet at your home or showroom, learn what is not working and define the priorities.'],
  ['02', 'Plan', 'We shape the scope, help with material selections and set clear expectations for the work.'],
  ['03', 'Build', 'Our team coordinates the renovation and keeps communication straightforward along the way.'],
  ['04', 'Enjoy', 'We walk the finished project with you and leave you with a home that feels renewed.']
];

export const testimonials = [
  ['Walter', 'Our floor remodel was seamless and the result exceeded our expectations.'],
  ['Sandy', 'They transformed our bathroom into a modern oasis. The attention to detail and material choices stood out.'],
  ['William', 'The bathroom design, fixtures and tile work came together beautifully.']
];

export const generalFaqs = [
  ['What types of renovation projects do you handle?', 'We focus on kitchens, bathrooms, flooring, countertops and coordinated whole-home interior renovations in Maricopa.'],
  ['Do you offer free consultations?', 'Yes. Contact us to schedule a free consultation at your home or begin the conversation at our Maricopa showroom.'],
  ['Where is your showroom?', 'Our showroom is at 41600 W Smith Enke Road, Building 2, Suite 110, Maricopa, Arizona 85138.'],
  ['Do you offer financing?', 'Financing options are available for qualified customers. Contact our team for current program details and terms.'],
  ['What areas do you serve?', 'Our primary service area is Maricopa, Arizona. Contact us with your address so we can confirm availability for your project.'],
  ['Are you a licensed contractor?', 'Maricopa Renovations displays Arizona ROC #294216. You can verify current license status directly with the Arizona Registrar of Contractors.']
];

export const findService = (slug) => services.find((service) => service.slug === slug);
export const findProject = (slug) => projects.find((project) => project.slug === slug);
